import { buildShareUrl } from '@/game/codec';
import type { GameState } from '@/game/types';

export async function shareGameLink(input: {
  state: GameState;
  title: string;
  text: string;
}): Promise<'shared' | 'copied'> {
  const url = buildShareUrl(window.location.origin, input.state);

  if (typeof navigator.share === 'function') {
    try {
      await navigator.share({ title: input.title, text: input.text, url });
      return 'shared';
    } catch (error) {
      if (error instanceof DOMException && error.name === 'AbortError') {
        throw error;
      }
    }
  }

  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(url);
    return 'copied';
  }

  const textarea = document.createElement('textarea');
  textarea.value = url;
  textarea.setAttribute('readonly', '');
  textarea.style.position = 'fixed';
  textarea.style.opacity = '0';
  document.body.appendChild(textarea);
  textarea.select();
  const ok = document.execCommand('copy');
  document.body.removeChild(textarea);
  if (!ok) {
    throw new Error('copy_failed');
  }
  return 'copied';
}
